import React from 'react';

export class DisplayError extends React.Component {
  render() {
    return (
      <div className="content-center">
        <div className="alert alert-danger">
          {this.props.children}
        </div>
      </div>
    );
  }
}
